import { useNavigate } from "react-router-dom";
import IFolderHeaderProps from "./IFolderHeaderProps";
import IFolder from "../../models/IFolder";
import { Col, Row } from "react-grid-system";
import { Button, Card, CardHeader, mergeClasses, Text } from "@fluentui/react-components";
import { ChevronLeftRegular, Notepad16Filled } from "@fluentui/react-icons";
import styles from './FolderHeader.module.scss';
import useStyleUtils from "../../utilities/styles";
import EditFolder from "../editFolder/EditFolder";
import { useTranslation } from "react-i18next";
import FolderAttributes from "../attributes/FolderAttributes";
import DeleteFolder from "../deleteFolder/DeleteFolder";

interface IFolderHeaderComponentProps {
    folder: IFolder;
}

const BackButton = (props: IFolderHeaderComponentProps) => {
    const { folder } = props;
    const navigate = useNavigate();

    const backUrl = folder.parentId ? `/f/${folder.parentId}` : '/';
    const handleBack = () => navigate(backUrl);
  
    return (
        <Col xs="content">
            <Button
            size='small'
            onClick={handleBack}
            icon={<ChevronLeftRegular />}
            />
        </Col>
    );
}

const NotesHeader = () => {
    const { t } = useTranslation();
    const style = useStyleUtils();

    const headerStyles = mergeClasses(style.dFlex, style.alignItemsCenter);

    return (
        <div className={headerStyles}>
            <Notepad16Filled className={style.mr1} />
            <Text weight="semibold">
                {t("folders.form.fields.notes.label")}
            </Text>
        </div>
    );
};

const Notes = (props: IFolderHeaderComponentProps) => {
    const style = useStyleUtils();

    return (
        <Card className={style.mt2}>
            <CardHeader header={<NotesHeader />} />
            <Text>
                {props.folder.notes}
            </Text>
        </Card>
    );
}

export default function FolderHeader(props: IFolderHeaderProps) {
    const { folder } = props;
    
    const style = useStyleUtils();

    return (
        <Row align="center" className={style.mb3}>
            <Col>
                <Row align="center">
                    <Col xs="content">
                        {
                            folder &&
                            <BackButton folder={folder} />
                        }
                    </Col>
                    <Col>
                        <div className={`${style.dFlex} ${style.alignItemsCenter}`}>
                            {
                                folder.logoUri &&
                                <img src={folder.logoUri} alt={folder.name} className={`${style.mr3} ${styles.logo}`} />
                            }
                            <div className={style.dBlock}>
                                <h2 className={`${style.mt0} ${style.mb1}`}>
                                    {folder.name}
                                </h2>
                                {
                                    folder.subtitle &&
                                    <h3 className={`${styles.subtitle} ${style.mt0} ${style.mb1}`}>
                                        {folder.subtitle}
                                    </h3>
                                }
                                {
                                    folder.url &&
                                    <a href={folder.url} target="_blank">
                                        {folder.url}
                                    </a>
                                }
                            </div>
                        </div>
                    </Col>
                    {
                        folder && 
                        <Col xs="content">
                            {
                                folder.attributes.length > 0 &&
                                <FolderAttributes folder={folder} />
                            }
                            <EditFolder folderId={folder.id} onUpdate={props.onSave} />
                            <DeleteFolder folderId={folder.id} onDelete={props.onDelete} />
                        </Col>
                    }
                </Row>
                <Row>
                    {
                        folder.notes &&
                        <Col xs={12}>
                            <Notes folder={folder} />
                        </Col>
                    }
                </Row>
            </Col>
        </Row>
    );
}